export default "__VITE_ASSET__kvJ3uIyv__"